module.exports = __webpack_public_path__ + "img/3.92845758.jpg";